export default "__VITE_ASSET__aXKow5qd__"